import { getConfig } from "../lib/config/index.ts";
import { getToken, isOfficeEnvironment } from "../lib/office/index.ts";
import { authResponseInterceptor } from "./auth-interceptor";
import { client } from "./generated/client.gen";

/**
 * Configures the Hey API client with authentication settings.
 * Must be called once at application startup before any API calls.
 */
export function configureApiClient(): void {
  const config = getConfig();

  client.setConfig({
    baseUrl: config.apiBaseUrl,
    credentials: "include", // Sends cookies with every request
  });

  client.interceptors.request.use((request) => {
    if (isOfficeEnvironment()) {
      const token = getToken();
      if (token) {
        request.headers.set("Authorization", `Bearer ${token}`);
      }
    }
    return request;
  });

  client.interceptors.response.use(authResponseInterceptor);
}
